import * as React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom"; // Added useLocation
import CustomerFooter from "./CustomerFooter";
import CustomerWithServiceHeader from "./CustomerWithServiceHeader";
import CategoryNav from "./CategoryNav";
import TopAnnouncementBar from "./TopAnnouncementBar";
import ScrollToTopForService from "../../components/customer/ScrollToTopForService";
import LoginModal from "../../components/customer/LoginModal";
import { MenuProvider } from "../../components/customer/MenuContext";

const CustomerMainLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleCartClick = () => {
    navigate("/cartpage/customercartpage");
  };

  // Always default to "Products" on page load/reopen
  const [mode, setMode] = React.useState<"Products" | "Pets" | "Services">(
    "Products"
  );

  React.useEffect(() => {
    localStorage.removeItem("selectedMode");
  }, []);

  const [showLoginModal, setShowLoginModal] = React.useState(false);

  const handleModeChange = (newMode: "Products" | "Pets" | "Services") => {
    setMode(newMode);

    if (location.pathname !== "/") {
      navigate("/");
    }
  };

  const   isProductPage =
    location.pathname.includes("/item");

  return (
    <MenuProvider>
      {/* Condition 1: Hide Announcement Bar on product pages */}
      {!isProductPage && (
        <div className="hidden md:block w-full bg-mainBrandColor">
          <div className="max-w-7xl mx-auto   w-full">
            <TopAnnouncementBar />
          </div>
        </div>
      )}
      <div className="bg-white w-full min-h-screen">
        {/* STICKY TOP-BAR SECTION CONTAINER WRAPPER (FULL-BLEED COLOR BAR) */}
        <div className="sticky top-0 z-50 bg-[#2F5E2E] w-full border-b border-emerald-800/20 shadow-xs">
          {/* INTERIOR FRAME CORE HEADER: CENTERS AND CLAMPS ALL SEARCH FIELDS AND LOGOS */}
          <div className="max-w-7xl mx-auto  w-full">
            <CustomerWithServiceHeader
              currentMode={mode}
              setCurrentMode={handleModeChange}
              handleCheckoutClick={handleCartClick}
              onLoginRequired={() => setShowLoginModal(true)}
            />
          </div>

          {/* INTERIOR FRAME NAVIGATION BAR: CLAMPS YOUR SECONDARY LIST STRINGS */}
          {!isProductPage && (
            <div className="w-full bg-[#3A6A39] backdrop-blur-xs border-t border-emerald-700/40">
              <div className="max-w-7xl mx-auto  w-full">
                <CategoryNav
                  currentMode={mode}
                  setCurrentMode={handleModeChange}
                  onLoginRequired={() => setShowLoginModal(true)}
                />
              </div>
            </div>
          )}

          <LoginModal
            isOpen={showLoginModal}
            onClose={() => setShowLoginModal(false)}
          />
        </div>

        <ScrollToTopForService mode={mode} />

        {/* Main Section */}
        <main className="flex-1 w-full max-w-7xl mx-auto box-border">
          <Outlet context={{ mode }} />
        </main>

        <CustomerFooter setCurrentMode={handleModeChange} />
      </div>
    </MenuProvider>
  );
};

export default CustomerMainLayout;
